angular.module("avant.customer_applications.controllers").controller "CustomerApplicationsLoanOfferCtrl", [
  "$controller"
  "$scope"
  "ApplicationService"
  "CustomerApplicationService"
  (
    $controller
    $scope
    ApplicationService
    CustomerApplicationService
  ) ->

    $scope.page = "loan_offer"
    $scope.stageFromState = () => $scope.page

    $scope.$emit("customer_application:data", ApplicationService.data)
    angular.extend(
      $scope,
      $controller(
        "CustomerApplicationsMixinCtrl"
        {
          $scope: $scope
          ApplicationService
          CustomerApplicationService
        }
      )
    )

    $scope.trackVisit()

    $scope.submit = ->
      $scope.$emit 'conversion:action', 'submit', 'loan_offer'
      $scope.submitWrapper (response_data) ->
        $scope.redirectIfDifferentPage response_data, ->
          # Some error occurred as page didn't change
          $scope.closeAllLoadingModals()
          if response_data.server_side_errors and response_data.server_side_errors.length > 0
            $scope.showServerSideErrors(response_data.server_side_errors)
]
